

document.addEventListener('DOMContentLoaded', function() {
  const frequently_purchased = document.querySelectorAll('.splide-cross_sells a')

  for (const product of frequently_purchased) {
    product.addEventListener('click', function() {
      selectItemConversion('frequently-purchased-with',
                   'frequently purchased with',
                   [
                     { 'item_name': product.innerText,
                       'index': parseInt(product.dataset.index)
                     }
                   ]
                  )
    });
  }

  const similar_products = document.querySelectorAll('.splide-upsells a')

  for (const product of similar_products) {
    product.addEventListener('click', function() {
      selectItemConversion('similar-products',
                  'similar products',
                  [
                    { 'item_name': product.innerText,
                      'index': parseInt(product.dataset.index)
                    }
                  ]
                 )
    });
  }

  const new_products = document.querySelectorAll('.home .et_pb_section_3 a')

  for (const product of new_products) {
    product.addEventListener('click', function() {
      selectItemConversion('new-products',
                  'new products',
                  [
                    { 'item_name': product.innerText,
                      'index': parseInt(product.dataset.index)
                    }
                  ]
                 )
    });
  }

  const clearance_products = document.querySelectorAll('.home .et_pb_section_4 a')

  for (const product of clearance_products) {
    product.addEventListener('click', function() {
      selectItemConversion('clearance-products',
                  'clearance products',
                  [
                    { 'item_name': product.innerText,
                      'index': parseInt(product.dataset.index)
                    }
                  ]
                 );
    });
  }

  const url = new URL(window.location.href);
  const slug = url.pathname.split('/').filter(n => n).pop();
  const name = slug.replace(/-/g, ' ');

  const products = document.querySelectorAll('a.woocommerce-loop-product__link');

  for (const product of products) {
    product.addEventListener('click', function() {
      selectItemConversion(slug, name, [
                                { 'item_name': product.innerText }
                              ]
                 );
    });
  }
});


function selectItemConversion(item_list_id, item_list_name, product) {
  dataLayer.push({ ecommerce: null });

  dataLayer.push({
    event: 'select_item',
    ecommerce: {
      item_list_id: item_list_id,
      item_list_name: item_list_name,
      items: product
    }
  });
}

jQuery(function() {
  // code to be triggered when the form confirmation page is loaded
  jQuery(document).on('gform_confirmation_loaded', function(event, formId){
    let form_name = 'form';

    if (formId == 1) {
      form_name = 'contact_us';
    } else if (formId == 3) {
      form_name = 'request_quote';
    }

    dataLayer.push({
      event: `${form_name}_submission`
    })
  });
});
